<template>
  <ul class="main_navigation">
    <nav-list-item
      v-for="navItem in list"
      :key="navItem.pathName"
      :text="navItem.text"
      :pathName="navItem.pathName"
      :icon="navItem.icon"
      :childClass="navItem.class"
      :has-sub-group="navItem.hasSubGroup"
      :items="navItem.items"
    />
  </ul>
</template>

<script>
import NavListItem from './NavListItem'

export default {
  name: 'nav-list',
  components: {
    NavListItem
  },
  props: {
    list: {
      type: Array
    }
  }
}
</script>
